<template>
	<div>
		<div class="d-flex justify-content-center align-items-center vh-100">
			<div class="d-block">
				<center>
					<span class="spinner-border spinner-border-sm-loader m-0" role="status" aria-hidden="true"></span>
					<h4 style="margin-top:15px"><span class="count">{{ percent }}</span> %</h4>
					<h5>Proses impor...</h5>
				</center>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOImportProgress",
	props: {
		context: String,
		trackerActions: String,
	},
	mounted() {
		this.runTracker()
	},
	data() {
		return {
			percent: "0",
			looper: null,
			delay: 5000,
		}
	},
	methods: {
		runTracker() {
			this.looper = setInterval(async () => {
				await this.tracker()
			}, this.delay);
		},
		async tracker() {
			const res = await this.$store.dispatch(this.trackerActions)
			if (res.success) {
				let progress = (parseFloat(res.data.data_created) / parseFloat(res.data.lenght_data)) * 100
				this.percent = progress.toFixed(2).replace(".", ",")

				switch (res.data.status_progress) {
					case "0": // onprogress
						break;
					case "1": // berhasil
						clearInterval(this.looper)
						this.$toast.success("Data " + this.context +" sukses di impor")

						this.$emit("on-success", res.data)
						break;
					case "2": // error
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)

						if (res.data.need_force !== undefined) {
							if (res.data.need_force === "1") {
								this.$emit("on-duplicate", res.data)
								break;
							}
						}
						this.$emit("on-error", res.data)
						break;
					case "3": // tidak ada progress
						clearInterval(this.looper)
						// this.$toast.error(res.data.msg_progress)

						this.$emit("on-success", res.data)
						break;
					default:
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)

						this.$emit("on-error", res.data)
						break;
				}
			} else {
				clearInterval(this.looper)
				this.$toast.error(res.err)

				this.$emit("on-error", res.data)
			}
		}
	}
}
</script>